export default "__VITE_ASSET__016c9922__"